// TODO-KPI-32 — "Ağırlıklı ortalama" konsolide kuralının ağırlık göstergesi seçicisi. Katalog
// (MetricModal) ve set (IndicatorModal) pencerelerinde yalnız kural Ağırlıklı ortalama iken
// görünür; ağırlık boşsa kaydetme sunucuda reddedilir — burada aynı mesaj önceden gösterilir.

import { KPI_COPY } from "../../lib/kpi-ui";
import { SearchSelect, type SearchSelectOption } from "../common/SearchSelect";
import { fieldStyle, labelStyle } from "./kpi-form-styles";

const COPY = KPI_COPY.aggregationWeight;

export interface AggregationWeightFieldProps {
  id: string;
  value: string;
  options: readonly SearchSelectOption[];
  /** set penceresinde "Katalog varsayılanı" satırı; katalogda verilmez */
  emptyLabel?: string | undefined;
  /** etkin ağırlık yok → zorunluluk mesajı */
  missing: boolean;
  disabled: boolean;
  onChange: (value: string) => void;
}

export function AggregationWeightField(props: AggregationWeightFieldProps): JSX.Element {
  const { id, value, options, emptyLabel, missing, disabled, onChange } = props;
  return (
    <div style={fieldStyle}>
      <label style={labelStyle} htmlFor={id}>
        {COPY.label}
      </label>
      <SearchSelect
        id={id}
        ariaLabel={COPY.label}
        value={value}
        options={options}
        emptyLabel={emptyLabel}
        placeholder={COPY.placeholder}
        searchPlaceholder={COPY.search}
        disabled={disabled}
        onChange={onChange}
      />
      <div
        className="text-xs"
        style={{ color: missing ? "var(--color-error)" : "var(--color-text-3)" }}
        role={missing ? "alert" : undefined}
      >
        {missing ? COPY.required : COPY.hint}
      </div>
    </div>
  );
}
